module.exports = __webpack_public_path__ + "static/media/assamwebp.0a3ba7ff.webp";